module.exports = __webpack_public_path__ + "images/application/paid-stamp-0abab67d.svg";